import Navbarheader from "./Navbarheader";
import HomeNavbarCategory from "./HomeNavbarCategory";

const HeaderComponent = () => {
	return (
		<>
			<Navbarheader />
			<HomeNavbarCategory />
		</>
	);
};

export default HeaderComponent;
